export default __webpack_public_path__ + "static/contactPageBg-20cbcd108586b1dbf94e775e565362bc.png";